import { render, staticRenderFns } from "./inputFace.vue?vue&type=template&id=3c494d32&scoped=true"
import script from "./inputFace.vue?vue&type=script&lang=js"
export * from "./inputFace.vue?vue&type=script&lang=js"
import style0 from "./inputFace.vue?vue&type=style&index=0&id=3c494d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c494d32",
  null
  
)

export default component.exports